/** Per-computer QC vs Shipping station (localStorage, not the user). */

export const WORKSTATION_MODE_KEY = "riverr.workstationMode";
export const QC_PREPARE_LABEL_KEY = "riverr.qcPrepareLabel";
export const WORKSTATION_MODE_EVENT = "riverr:workstation-mode";
export const QC_PREPARE_LABEL_EVENT = "riverr:qc-prepare-label";

export const WORKSTATION_QC = "qc";
export const WORKSTATION_SHIPPING = "shipping";

export function readWorkstationMode() {
  try {
    const raw = String(localStorage.getItem(WORKSTATION_MODE_KEY) || "").trim();
    if (raw === WORKSTATION_QC) return WORKSTATION_QC;
  } catch (_err) {
    /* private mode / SSR */
  }
  return WORKSTATION_SHIPPING;
}

export function writeWorkstationMode(mode) {
  const next = mode === WORKSTATION_QC ? WORKSTATION_QC : WORKSTATION_SHIPPING;
  try {
    localStorage.setItem(WORKSTATION_MODE_KEY, next);
  } catch (_err) {
    /* ignore quota / private mode */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(WORKSTATION_MODE_EVENT, { detail: next })
    );
  }
  return next;
}

export function readQcPrepareLabel() {
  try {
    const raw = localStorage.getItem(QC_PREPARE_LABEL_KEY);
    if (raw == null) return true;
    return raw !== "0" && raw !== "false";
  } catch (_err) {
    return true;
  }
}

export function writeQcPrepareLabel(enabled) {
  const next = Boolean(enabled);
  try {
    localStorage.setItem(QC_PREPARE_LABEL_KEY, next ? "1" : "0");
  } catch (_err) {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(QC_PREPARE_LABEL_EVENT, { detail: next })
    );
  }
  return next;
}
